 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddFileModal":"AddFileModal","AdminControlModal":"AdminControlModal","AskSubModal":"AskSubModal","AudioOnboarding~ModalChrome~TranscriptOnboarding":"AudioOnboarding~ModalChrome~TranscriptOnboarding","AudioOnboarding":"AudioOnboarding","TranscriptOnboarding":"TranscriptOnboarding","AudioPlayerUpload":"AudioPlayerUpload","BrandKit~ClipperExportModal~SmartEditModal":"BrandKit~ClipperExportModal~SmartEditModal","SmartEditModal":"SmartEditModal","ClipEditor~ClipperExportModal~HomeProse~SpextPlayer~WelcomeModal":"ClipEditor~ClipperExportModal~HomeProse~SpextPlayer~WelcomeModal","BrandKit~ClipperExportModal":"BrandKit~ClipperExportModal","ClipperExportModal":"ClipperExportModal","ClipEditor~HomeProse~SpextPlayer~WelcomeModal":"ClipEditor~HomeProse~SpextPlayer~WelcomeModal","SpextPlayer":"SpextPlayer","WelcomeModal":"WelcomeModal","ClipEditor~HomeProse~Privacy~TeamInvite~drive~security":"ClipEditor~HomeProse~Privacy~TeamInvite~drive~security","HomeProse":"HomeProse","Header":"Header","ClipEditor":"ClipEditor","TeamInvite~drive":"TeamInvite~drive","drive":"drive","Privacy":"Privacy","TeamInvite":"TeamInvite","security":"security","ClipperExportMessage":"ClipperExportMessage","EditMediaPrompt":"EditMediaPrompt","EditTranscriptPrompt":"EditTranscriptPrompt","ErrorMessage":"ErrorMessage","ExportMessage":"ExportMessage","Form":"Form","BrandKit":"BrandKit","LandingPage":"LandingPage","Invite":"Invite","InviteModal":"InviteModal","Onboarding":"Onboarding","PlansTab":"PlansTab","ShutDownNotice":"ShutDownNotice","UploadItemForUpload":"UploadItemForUpload","UploadStatus":"UploadStatus","AddFileSounds":"AddFileSounds","AddFileSpextDoc":"AddFileSpextDoc","AddFileUploadMedia":"AddFileUploadMedia","SideBar":"SideBar","Footer":"Footer","AddActionPopover":"AddActionPopover","ModalChrome":"ModalChrome","AutopilotWordsPanel":"AutopilotWordsPanel","BlockModeV2":"BlockModeV2","BlockmodePanel":"BlockmodePanel","EditorSearch":"EditorSearch","ExportedFiles":"ExportedFiles","ModalPublish":"ModalPublish","ShareModal":"ShareModal","SiderBarComments":"SiderBarComments","FirstUpload":"FirstUpload","VerifyEmail":"VerifyEmail","DriveHeader":"DriveHeader","MusicLibrary":"MusicLibrary","SyntheticVoices":"SyntheticVoices","YourMedia":"YourMedia","AddFilesFooter":"AddFilesFooter","AddLabelPopover":"AddLabelPopover","TagIcon":"TagIcon","AudioControls":"AudioControls","ProgressBar":"ProgressBar"}[chunkId]||chunkId) + "." + {"AddFileModal":"921c9b31","AdminControlModal":"a5ada9c9","AskSubModal":"52b10045","AudioOnboarding~ModalChrome~TranscriptOnboarding":"5f070b71","AudioOnboarding":"fd088012","TranscriptOnboarding":"20a2102c","AudioPlayerUpload":"aaa274a1","BrandKit~ClipperExportModal~SmartEditModal":"27441e7b","SmartEditModal":"9eceeaa0","ClipEditor~ClipperExportModal~HomeProse~SpextPlayer~WelcomeModal":"50551538","BrandKit~ClipperExportModal":"71070e4b","ClipperExportModal":"915266d3","ClipEditor~HomeProse~SpextPlayer~WelcomeModal":"f26b304c","SpextPlayer":"1bb69379","WelcomeModal":"10a5f06b","ClipEditor~HomeProse~Privacy~TeamInvite~drive~security":"916a317f","HomeProse":"2f6ef43b","Header":"ee38d77b","ClipEditor":"56fe0c1f","TeamInvite~drive":"39d68815","drive":"be07c76b","Privacy":"baf7e312","TeamInvite":"93309752","security":"cd382631","ClipperExportMessage":"2175df18","EditMediaPrompt":"860fcf96","EditTranscriptPrompt":"4c667b05","ErrorMessage":"3146aaf9","ExportMessage":"897f3ab7","Form":"e44bcc7e","BrandKit":"fcc75bd9","LandingPage":"33fd58e1","Invite":"811be946","InviteModal":"3a4c9172","Onboarding":"94f87fef","PlansTab":"faa3ec85","ShutDownNotice":"bb0d1742","UploadItemForUpload":"96cb4181","UploadStatus":"6fe7b42b","AddFileSounds":"27c8617b","AddFileSpextDoc":"db8e0245","AddFileUploadMedia":"fb6f8250","SideBar":"186ecec9","Footer":"b6053cbd","AddActionPopover":"d5f0b9de","ModalChrome":"806f5594","AutopilotWordsPanel":"26ac8a9a","BlockModeV2":"ef9c0fe0","BlockmodePanel":"cff32f43","EditorSearch":"ff9930d4","ExportedFiles":"0540cd6a","ModalPublish":"5cea5329","ShareModal":"2e52b77a","SiderBarComments":"57daa77f","FirstUpload":"ae5d2678","VerifyEmail":"abc736ad","chunk-5fdd0ea5":"33837062","DriveHeader":"ed8a95f9","MusicLibrary":"8122945f","SyntheticVoices":"15b8e5a4","YourMedia":"47d43354","AddFilesFooter":"1e650101","AddLabelPopover":"8585d316","TagIcon":"f4955d91","AudioControls":"d812cbd7","ProgressBar":"7b28730d","chunk-1cd03cd6":"6eb43062"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AddFileModal":1,"AdminControlModal":1,"AskSubModal":1,"AudioOnboarding~ModalChrome~TranscriptOnboarding":1,"AudioOnboarding":1,"TranscriptOnboarding":1,"AudioPlayerUpload":1,"BrandKit~ClipperExportModal~SmartEditModal":1,"SmartEditModal":1,"BrandKit~ClipperExportModal":1,"ClipperExportModal":1,"ClipEditor~HomeProse~SpextPlayer~WelcomeModal":1,"SpextPlayer":1,"WelcomeModal":1,"ClipEditor~HomeProse~Privacy~TeamInvite~drive~security":1,"HomeProse":1,"Header":1,"ClipEditor":1,"TeamInvite~drive":1,"drive":1,"Privacy":1,"security":1,"ClipperExportMessage":1,"EditMediaPrompt":1,"EditTranscriptPrompt":1,"ErrorMessage":1,"ExportMessage":1,"BrandKit":1,"LandingPage":1,"InviteModal":1,"ShutDownNotice":1,"UploadItemForUpload":1,"AddFileSounds":1,"AddFileSpextDoc":1,"AddFileUploadMedia":1,"SideBar":1,"Footer":1,"AddActionPopover":1,"ModalChrome":1,"AutopilotWordsPanel":1,"BlockModeV2":1,"BlockmodePanel":1,"EditorSearch":1,"ExportedFiles":1,"ModalPublish":1,"ShareModal":1,"SiderBarComments":1,"VerifyEmail":1,"chunk-5fdd0ea5":1,"MusicLibrary":1,"SyntheticVoices":1,"YourMedia":1,"AddLabelPopover":1,"TagIcon":1,"AudioControls":1,"ProgressBar":1,"chunk-1cd03cd6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddFileModal":"AddFileModal","AdminControlModal":"AdminControlModal","AskSubModal":"AskSubModal","AudioOnboarding~ModalChrome~TranscriptOnboarding":"AudioOnboarding~ModalChrome~TranscriptOnboarding","AudioOnboarding":"AudioOnboarding","TranscriptOnboarding":"TranscriptOnboarding","AudioPlayerUpload":"AudioPlayerUpload","BrandKit~ClipperExportModal~SmartEditModal":"BrandKit~ClipperExportModal~SmartEditModal","SmartEditModal":"SmartEditModal","ClipEditor~ClipperExportModal~HomeProse~SpextPlayer~WelcomeModal":"ClipEditor~ClipperExportModal~HomeProse~SpextPlayer~WelcomeModal","BrandKit~ClipperExportModal":"BrandKit~ClipperExportModal","ClipperExportModal":"ClipperExportModal","ClipEditor~HomeProse~SpextPlayer~WelcomeModal":"ClipEditor~HomeProse~SpextPlayer~WelcomeModal","SpextPlayer":"SpextPlayer","WelcomeModal":"WelcomeModal","ClipEditor~HomeProse~Privacy~TeamInvite~drive~security":"ClipEditor~HomeProse~Privacy~TeamInvite~drive~security","HomeProse":"HomeProse","Header":"Header","ClipEditor":"ClipEditor","TeamInvite~drive":"TeamInvite~drive","drive":"drive","Privacy":"Privacy","TeamInvite":"TeamInvite","security":"security","ClipperExportMessage":"ClipperExportMessage","EditMediaPrompt":"EditMediaPrompt","EditTranscriptPrompt":"EditTranscriptPrompt","ErrorMessage":"ErrorMessage","ExportMessage":"ExportMessage","Form":"Form","BrandKit":"BrandKit","LandingPage":"LandingPage","Invite":"Invite","InviteModal":"InviteModal","Onboarding":"Onboarding","PlansTab":"PlansTab","ShutDownNotice":"ShutDownNotice","UploadItemForUpload":"UploadItemForUpload","UploadStatus":"UploadStatus","AddFileSounds":"AddFileSounds","AddFileSpextDoc":"AddFileSpextDoc","AddFileUploadMedia":"AddFileUploadMedia","SideBar":"SideBar","Footer":"Footer","AddActionPopover":"AddActionPopover","ModalChrome":"ModalChrome","AutopilotWordsPanel":"AutopilotWordsPanel","BlockModeV2":"BlockModeV2","BlockmodePanel":"BlockmodePanel","EditorSearch":"EditorSearch","ExportedFiles":"ExportedFiles","ModalPublish":"ModalPublish","ShareModal":"ShareModal","SiderBarComments":"SiderBarComments","FirstUpload":"FirstUpload","VerifyEmail":"VerifyEmail","DriveHeader":"DriveHeader","MusicLibrary":"MusicLibrary","SyntheticVoices":"SyntheticVoices","YourMedia":"YourMedia","AddFilesFooter":"AddFilesFooter","AddLabelPopover":"AddLabelPopover","TagIcon":"TagIcon","AudioControls":"AudioControls","ProgressBar":"ProgressBar"}[chunkId]||chunkId) + "." + {"AddFileModal":"77a7ed22","AdminControlModal":"e4594a1d","AskSubModal":"4893acfe","AudioOnboarding~ModalChrome~TranscriptOnboarding":"06329579","AudioOnboarding":"aa926dd7","TranscriptOnboarding":"b9d08633","AudioPlayerUpload":"75c44202","BrandKit~ClipperExportModal~SmartEditModal":"acdd3974","SmartEditModal":"3e830069","ClipEditor~ClipperExportModal~HomeProse~SpextPlayer~WelcomeModal":"31d6cfe0","BrandKit~ClipperExportModal":"2a78a2ec","ClipperExportModal":"dd9a3b2d","ClipEditor~HomeProse~SpextPlayer~WelcomeModal":"28ecc543","SpextPlayer":"afc51b1e","WelcomeModal":"48c36c3e","ClipEditor~HomeProse~Privacy~TeamInvite~drive~security":"527703ab","HomeProse":"5f96e4a9","Header":"46ab50e7","ClipEditor":"916c33fc","TeamInvite~drive":"d00819f3","drive":"d1b95714","Privacy":"1eb0875b","TeamInvite":"31d6cfe0","security":"f5da2e66","ClipperExportMessage":"7e94e2f1","EditMediaPrompt":"3ce86f07","EditTranscriptPrompt":"5e92f04e","ErrorMessage":"00084311","ExportMessage":"4a94b27f","Form":"31d6cfe0","BrandKit":"2c9614ee","LandingPage":"2e160c9f","Invite":"31d6cfe0","InviteModal":"02a6f622","Onboarding":"31d6cfe0","PlansTab":"31d6cfe0","ShutDownNotice":"b704ac1d","UploadItemForUpload":"e29717c6","UploadStatus":"31d6cfe0","AddFileSounds":"8ce9ac3c","AddFileSpextDoc":"d7a87441","AddFileUploadMedia":"666b8d44","SideBar":"7943c1db","Footer":"3416d916","AddActionPopover":"6a59ecbe","ModalChrome":"18c296e7","AutopilotWordsPanel":"b4a347a7","BlockModeV2":"9c6339f7","BlockmodePanel":"aad664bf","EditorSearch":"42dc4d97","ExportedFiles":"c0339f1f","ModalPublish":"38b561d0","ShareModal":"0d398c02","SiderBarComments":"c1e48825","FirstUpload":"31d6cfe0","VerifyEmail":"c2941e67","chunk-5fdd0ea5":"ff90e86e","DriveHeader":"31d6cfe0","MusicLibrary":"73df4c60","SyntheticVoices":"9ad6588c","YourMedia":"10b67242","AddFilesFooter":"31d6cfe0","AddLabelPopover":"1b99faf8","TagIcon":"acf9959b","AudioControls":"e54e31dd","ProgressBar":"05cc18ab","chunk-1cd03cd6":"6e9c1f82"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
